<template>
     <back-layout title="Empresas">
        <template #header>
            <h2 class="font-semibold text-2xl lg:text-4xl text-gray-300 leading-tight mb-4 md:mb-0 px-4">Empresas</h2>
        </template>

        <div class="py-12">
            <div class="container mx-auto px-4">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-10">
                   lista
                </div>
            </div>
        </div>
    </back-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
   

    export default defineComponent({
        components: {
            Head,
            Link,
            BackLayout,
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
        },
        data() {
            return {
            }
        },
        methods: {
        },
    })
</script>